import React from 'react';
import useDocumentTitle from '../hooks/useDocumentTitle';
import useMain from '../hooks/useMain';
import Image from './common/image';

const UnderMaintenance = () => {
	useDocumentTitle(['Under Maintenance']);
	const { theme } = useMain();
	return (
		<main className='container'>
			<div className='row my-5'>
				<div className='col-md-8 offset-md-2 col text-center'>
					<Image
						className='w-100'
						fileName={`utility_${theme}/underMaintenance.webp`}
					/>
					<h1>Maintenance</h1>
					<p className='text-my-danger'>
						<b>503 - Service is currently unavailable!</b>
					</p>
					<h5>We will come back online shortly.</h5>
				</div>
			</div>
		</main>
	);
};

export default UnderMaintenance;
